<template>
    <span class="typing" aria-label="AI пишет">
        <span class="dot" />
        <span class="dot" />
        <span class="dot" />
    </span>
</template>

<style scoped>
.typing {
    display: inline-flex;
    gap: 4px;
    align-items: center;
    padding: 4px 0;
}

.dot {
    width: 6px;
    height: 6px;
    background: #23282C;
    border-radius: 50%;
    animation: chat-blink 1.2s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.2s;
}

.dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes chat-blink {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 1; }
}
</style>
